module.exports = __webpack_public_path__ + "077379d81f135f5b96238e5bd408be10.png";